var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 12.5C25 19.4036 19.4036 25 12.5 25C5.59644 25 0 19.4036 0 12.5C0 5.59644 5.59644 0 12.5 0C19.4036 0 25 5.59644 25 12.5ZM5.52003 6.713C5.9252 6.23693 6.63958 6.17945 7.11564 6.58461L12.632 11.2794L18.1484 6.58469C18.6244 6.17953 19.3388 6.237 19.744 6.71307C20.1491 7.18914 20.0917 7.90352 19.6156 8.30869L14.3785 12.7658L19.6156 17.2229C20.0917 17.6281 20.1492 18.3425 19.744 18.8185C19.3389 19.2946 18.6245 19.3521 18.1484 18.9469L12.632 14.2521L7.11559 18.947C6.63952 19.3521 5.92514 19.2947 5.51998 18.8186C5.11481 18.3425 5.17229 17.6282 5.64836 17.223L10.8856 12.7658L5.64841 8.30861C5.17235 7.90344 5.11487 7.18906 5.52003 6.713Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.b1561b850499ed2998d9ecb862cd1f37.svg";
export { ForwardRef as ReactComponent };